import { useFramework } from '@suntex.fim/framework';
import { usePlayerDashboardPath } from '@suntex.fim/nav';
import { usePlayerContext } from '@suntex.fim/player';

export const CDN_BASE =
  (import.meta.env.VITE_FIM_CDN_URL as string | undefined) ??
  'https://cdn.firstinmath.com/content/animate/live/';

export const SOUND_DIRECTORY = `${CDN_BASE}sounds/`;
export const IMAGE_DIRECTORY = `${CDN_BASE}images/`;

/**
 * Props every module view takes from the surrounding page: the API client, the
 * current player, preview mode, and the URL to return to the hub.
 */
export function useModuleViewProps() {
  const { api } = useFramework();
  const { playerId, isPreview } = usePlayerContext();
  const hubUrl = usePlayerDashboardPath();
  return { api, playerId, preview: isPreview, hubUrl };
}
